/**
 * Renders nothing without `onRetry`, as for a recorded refusal: a refusal is a measured result,
 * which Retry would only measure again, so there is nothing for the reader to do about it.
 */
export const DesignRefitNotice = (props: { pending?: boolean; onRetry?: () => void }) =>
  props.onRetry ? (
    <span role="status" className="text-xs text-neutral-500 dark:text-neutral-400">
      {props.pending ? 'Still updating to its Design.' : 'Couldn’t apply the Design’s layout.'}{' '}
      <button
        type="button"
        onClick={props.onRetry}
        className="font-medium text-neutral-700 underline dark:text-neutral-200"
      >
        Retry
      </button>
    </span>
  ) : null;
